export const environment = {
    production: false,

    firebase: {
        apiKey: "AIzaSyBZZale7yCqF4sgVZ9ivYh7uIO_U2GHqWA",
        authDomain: "admisionplus-dev.firebaseapp.com",
        projectId: "admisionplus-dev",
        storageBucket: "admisionplus-dev.firebasestorage.app",
        messagingSenderId: "989524230505",
        appId: "1:989524230505:web:ff80cd1e50426b25477df8",
        measurementId: "G-R4X27KQZ7E",
    },
};
